import {
  currencyString,
  formatDate,
  isDefined,
  isFullPayoffPayment,
  isInstallmentBeforeScheduledDate,
  isLocOnOrBeforeScheduledDate,
  UseMessageT,
} from '@consumer-frontend/nc-utils';

export const useMessageEarlyFullPayoff: UseMessageT = (props) => {
  const {
    fullPayoffAmount,
    isAutopay,
    isAutopayPending,
    loanStatus,
    isFullPayoffDisabled,
    isMultiple,
    isNextMinimumPaymentDisabled,
    paymentAmount,
    paymentDate,
    productType,
    scheduledAmount,
    scheduledDate,
  } = props;

  if (!isDefined(paymentAmount)
    || !isDefined(paymentDate)
    || !isDefined(productType)
    || !isDefined(scheduledAmount)
    || !isDefined(scheduledDate)
    || !isDefined(fullPayoffAmount)
  ) { return undefined; }

  const logicHelperProps = {
    paymentDate,
    productType,
    scheduledDate,
  };

  const fullPayoffProps = {
    fullPayoffAmount,
    isFullPayoffDisabled,
    paymentAmount,
  };

  // NCFE-10081 (D-3)
  if (isAutopay
    && !isAutopayPending
    && loanStatus === 'current'
    && paymentAmount >= scheduledAmount
    && isFullPayoffPayment(fullPayoffProps)
    && (
      isInstallmentBeforeScheduledDate(logicHelperProps)
        || isLocOnOrBeforeScheduledDate(logicHelperProps)
    )
    && !isNextMinimumPaymentDisabled
    && !isFullPayoffDisabled
  ) {
    return (
      <p>
        Paying off your full balance will{' '}
        <span className="fw-bold">
          cancel your AutoPay {isMultiple ? 'payments' : 'payment'}
        </span>{' '}
        {isMultiple ? 'totaling ' : 'of '}
        {currencyString(scheduledAmount)} scheduled for {formatDate(scheduledDate)}.
      </p>
    );
  }

  return undefined;
};
